import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { ShopifyCopySource } from 'app/model/pipeline/copysource/shopify.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ShopifyCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class ShopifyCopySourceAdapter extends CopySourceAdapter<ShopifyCopySource, Model.ShopifySource> {
    protected override async _toResource(copySource: ShopifyCopySource): Promise<Model.ShopifySource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(ShopifyCopySource).name);
    }

    protected override async _toModel(
        resource: Model.ShopifySource,
        copyActivity: CopyActivity
    ): Promise<ShopifyCopySource> {
        return this._toTabularModel(resource, copyActivity, ShopifyCopySource.MODEL);
    }
}
